import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance-mastertables',
  templateUrl: './maintenance-mastertables.component.html',
  styleUrls: ['./maintenance-mastertables.component.sass']
})
export class MaintenanceMastertablesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
